import { useState } from "react";
import { useTranslation } from "react-i18next";
import DataTable from "../common/components/DataTable";
import { DefaultButton } from "../common/components/DefaultButton";
import { FloatingLabel } from "../common/components/FloatingLabel";
import PropTypes from 'prop-types';
import DecisionDialog from "./DecisionDialog";
import { deepClone } from "../common/utils/objectUtilities";

const formToSummary = form => {
    const summary = deepClone(form);
    summary.forEach(section => {
        section.rows = section.rows.filter(row => row.filter(c => c.summary)).filter(row => row.length > 0);
    })
    return summary.filter(section => section.rows.length > 0);
}

/**
 * Display decisions referncing the specified job and allow the decision details to be viewed.
 * @component
 */
const DecisionTable = ({ decisions, style }) => {
    const { t } = useTranslation();
    const [decision, setDecision] = useState();

    const tableDef = [
        { title: t('dateTime'), type: "date", editable: false, readonly: true, field: 'timestamp', uuid: 'timestamp_date' },
        { title: t('timeOfDay'), type: "time", editable: false, readonly: true, field: 'timestamp', uuid: 'timestamp_time' },
        { title: t('creator'), type: "text", editable: false, readonly: true, field: 'creator' },
        { title: t('decision', { count: 1 }), type: "number", editable: false, readonly: true, field: "id"},
        { title: t('details'), type: "form", editable: false, readonly: true, field: "data", def: value => formToSummary(value.definition) },
        { title: " ", key: 'view', type: "dynamic", editable: false, readonly: true, def: (value, disabled, hideLabel, onChange) => <div className="w-100 text-right"><FloatingLabel hideLabel={true} placeholder=" "><DefaultButton kind="view" onClick={() => setDecision(value)}></DefaultButton></FloatingLabel></div>}
    ]
    return <>
        { decision ? <DecisionDialog decision={decision} disabled={true} onClose={() => setDecision()}></DecisionDialog> : null }
        <DataTable columns={tableDef} disabled={true} value={decisions} emptyMessage={t('noJobDecisions')} style={style}></DataTable>
    </>
}

DecisionTable.propTypes = {
    /**
     * The decisions to display
     */
    decisions: PropTypes.array,
    /**
     * Style for the rendered table
     */
    style: PropTypes.object
}

export default DecisionTable;